// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA6DQvzwPjyFP3m96v36rtaGOq8GjxgM_4",
  authDomain: "beerflight-49b85.firebaseapp.com",
  projectId: "beerflight-49b85",
  storageBucket: "beerflight-49b85.firebasestorage.app",
  messagingSenderId: "707458664310",
  appId: "1:707458664310:web:cd6875971a6f018f1d9c57",
  measurementId: "G-TPBEM1SYMM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
// const analytics = getAnalytics(app);
